import React from "react";

// Bien tansformer les parenthéses en accolades si on nclus des fonctions avant le return
const Victory = () => {
  return <p className="textWhite"> WIN !</p>;
};

export default Victory;
